import React from 'react';
import { Navbar } from '../components/Navbar';
import { ContactPage } from '../components/ContactPage';
import { Footer } from '../components/Footer';
export const Contact = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2341">
      <Navbar data-id="element-2342" />
      <ContactPage data-id="element-2343" />
      <Footer data-id="element-2344" />
    </div>;
};